<template>
<div class="tab-inner-left">
  <div class="form-module">
    <h2>Scratch Type</h2>
    <p>Choose scratch type.</p>
    <select class="al-select" v-model="scratchType" @change="update_data(null)">
      <option v-for="option in scratchTypeOptions" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
  <div class="form-module">
    <h2>Campaign Name</h2>
    <p>Give a name to your campaign. This name will be visible to you in your <strong>Campaigns</strong> page. This name also will be used as a <strong>link</strong> to your campaign.</p>
    <input @input="update_data" type="text" @focus="campaign_name_focused = true"
           @blur="campaign_name_focused = false" v-model="name"
           class="al-input" placeholder="Enter campaign name here..."
           ref="Campaign Name"
           name="Campaign Name"
           data-vv-name="Campaign Name"
           v-validate="'required'"
    />
    <span class="text-danger text-sm" v-show="errors.has('Campaign Name')">{{ errors.first('Campaign Name') }}</span>
  </div>
  <div class="form-module">
    <h2>Campaign Logo</h2>
    <p>Upload your company logo or related campaign visual here.</p>
    <upload-image :required="this.logo_id === ''" :img_id="(this.logo_id === '') ? null : this.logo_id" :code="'logo-image'" :index="-1" :callback="logoUploaded" />
  </div>
  <div class="form-module">
    <h2>Ratings</h2>
    <p>Allow your customers to rate your establishment after they complete your campaign</p>
    <div class="preview-wrapper">
      <div class="flex">
        <span style="color: #AEAEAE">Disabled</span>
        <vs-switch class="switch-button mx-2" v-model="rate_available" @change="update_data(null)" />
        <span style="color: #AEAEAE">Enabled</span>
      </div>
    </div>
  </div>

  <div class="form-module">
    <h2>End Date</h2>
    <p>Please enter the end date of the campaign.</p>
    <input @input="update_data" type="date" class="al-input" v-model="endDate"
            placeholder="Enter campaign name here..."
           ref="End Date"
           name="End Date"
           data-vv-name="End Date"
           v-validate="'required'"/>
  </div>
 </div>
</template>

<script>
import UploadImage from '../../../../layouts/components/navbar/UploadImage'
import moment from 'moment'
export default {
  props: {
    update: {
      type: Function
    },
    dataVal: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      create: true,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      name: '',
      endDate: '',
      logo_id: '',
      rate_available: true,
      title: '',
      offer: '',
      campaign_image_id: '',
      scratchType: 'normal',
      scratchTypeOptions: [ // Seçeneklerin listesi
        { value: 'normal', text: 'Scratch-Off Campaign' },
        { value: 'quickly', text: 'Quick Campaign' }
        /*{ value: 'survey', text: 'Survey Card Scratch' }*/
      ],
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'End Date',
          type: 'date',
          code: 'endDate',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'ZIP Code',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: [],
      prizeList: [],
      prizeDefault: {
        name: '',
        image_id: ''
      },
      campaign_name_focused: false,
      campaign_slogan_focused: false,
      campaign_award_focused: false
    }
  },
  components: {
    UploadImage
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.set_data()
  },
  watch: {
    campaign_name_focused () {
      this.update_data()
    },
    dataVal () {
      this.set_data()
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    }
  },
  methods: {

    set_data () {
      const { name, logo_id, rate_available, endDate, scratchType } = JSON.parse(JSON.stringify(this.dataVal))
      this.name = name
      this.endDate = moment(endDate).format('YYYY-MM-DD')
      this.logo_id = logo_id
      this.rate_available = rate_available
      this.scratchType = scratchType

      console.log('setting data', this.dataVal)
    },
    update_data (ref) {
      this.update(this.name, this.campaign_name_focused, this.logo_id, this.rate_available, this.endDate, this.scratchType)
      if (ref) {
        this.$store.commit('SET_EDITING_NOW', ref)
      }
    },
    logoUploaded (result) {
      console.log('logo', result)
      this.logo_id = result
      this.update(this.name, this.campaign_name_focused, this.logo_id, this.rate_available, this.endDate, this.scratchType)
      this.update_data('campaignLogo')
    },
    uploadImage (callback) {
      if (this.uploadImg !== null) {

        const img_obj = {
          file: this.uploadImg
        }
        console.log('uploading image', img_obj)
        this.$store.dispatch('api/uploadImage', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          console.log('upload image', response)
          callback(response)
          this.$vs.notify({
            title: 'Success',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
        }).catch(err => {
          console.log(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
      }
    }
  }
}
</script>
<style lang="scss">
.tab-inner-left>.form-module {
  padding: 20px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 52, 81, 0.20)
}
.form-module h2 {
  color: #003451;
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H3 */
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
  border-bottom: 1px solid #C8D2D2;
  margin-bottom: 20px
}
.form-module p {
  color: #003451;

  /* Paragraph Styles/Paragraph Large */
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}
</style>
